
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoBankGrid extends Serenity.EntityGrid<PoBankRow, any> {
        protected getColumnsKey() { return PoBankColumns.columnsKey; }
        protected getDialogType() { return PoBankDialog; }
        protected getIdProperty() { return PoBankRow.idProperty; }
        protected getInsertPermission() { return PoBankRow.insertPermission; }
        protected getLocalTextPrefix() { return PoBankRow.localTextPrefix; }
        protected getService() { return PoBankService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}